import { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router";

const useMainNavigationPulseAnimation = () => {
  const location = useLocation();
  const [pathname, setPathname] = useState(location.pathname);
  const [isPulsing, setIsPulsing] = useState(true);

  if (pathname !== location.pathname) {
    setPathname(location.pathname);
    setIsPulsing(true);
  }

  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      setIsPulsing(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return isPulsing;
};

export default useMainNavigationPulseAnimation;
